import styled from 'styled-components';
export var EditAction = styled.span.withConfig({
  displayName: "partials__EditAction",
  componentId: "sc-1rr84yv-0"
})(["margin-left:4px;cursor:pointer;vertical-align:middle;&:hover{color:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});
export var Inner = styled.span.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-1rr84yv-1"
})(["display:inline-block;"]);